import React, { FC } from "react";
import { SVGProps } from "react";

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const IndicatorIcon: FC<IconProps> = (props) => {
  const { size = 20, viewBox, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 20 20`}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17542 7.82895H7.4945L5.84976 15.2303L5.65239 15.2632L4.92871 14.0132L3.33331 14.9836L4.3695 16.6447C4.53397 16.9189 4.76423 17.1272 5.06029 17.2697C5.3673 17.4232 5.6798 17.5 5.99779 17.5C6.38156 17.5 6.73792 17.3794 7.06687 17.1382C7.39581 16.9079 7.62059 16.5241 7.74121 15.9868L9.56687 7.82895H12.7741V5.85526H9.9945L10.1919 4.96711C10.2577 4.63816 10.4386 4.47368 10.7346 4.47368H13.2017V2.5H10.307C10.0767 2.5 9.84647 2.54386 9.61621 2.63158C9.39691 2.7193 9.19406 2.83991 9.00766 2.99342C8.83222 3.13597 8.67871 3.3114 8.54713 3.51974C8.41555 3.72807 8.32783 3.94737 8.28397 4.17763L7.92213 5.85526H5.17542V7.82895ZM14.3413 15.0787L13.7866 13.7667L15.8346 11.8467L14.928 10.8973L13.2426 12.476L12.9013 11.6653C12.6595 11.1107 12.2755 10.8333 11.7493 10.8333C11.2302 10.8333 10.8178 11.0751 10.512 11.5587L9.99998 12.348L11.024 13.0093L11.536 12.188H11.664L12.1973 13.4573L10.064 15.452L10.9706 16.4013L12.7306 14.748L13.0826 15.5693C13.2035 15.868 13.3564 16.0849 13.5413 16.22C13.7333 16.3551 13.9786 16.4227 14.2773 16.4227C14.8818 16.4227 15.3262 16.1311 15.6106 15.548L15.952 14.8653L14.8853 14.3107L14.4693 15.0787H14.3413Z"
      />
    </svg>
  );
};
